import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

// TODO: l10n review — translations are functional equivalents of the Spanish source
export const en: TTranslations = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Learning',
    PAGE_SUBTITLE:
      'Track usage of the learning platform. Own courses vs Crehana catalog, quarterly trends, certifications and satisfaction.',
    NEW_TAG: 'New',
    FRESHNESS_PREFIX: 'Last updated:',
    FRESHNESS_DATE: 'May 14, 09:00 AM',
    PRODUCT_SELECTOR_LABEL: 'Product',
    PRODUCT_SELECTOR_HELPER: 'Select the product you want to analyze',
    PRODUCT_GENERAL: 'General',
    PRODUCT_LEARNING: 'Learning',
    BREADCRUMB_ROOT: 'Analytics Hub',
    BREADCRUMB_DASHBOARDS: 'Dashboards',
    BREADCRUMB_LEARNING: 'Learning',
    TAB_GENERAL: 'General',
    TAB_PATHS: 'By paths',
    TAB_COURSES: 'By courses',
    TAB_USERS: 'By users',
    TAB_PLACEHOLDER_PATHS: 'Paths content coming soon',
    TAB_PLACEHOLDER_COURSES: 'Courses content coming soon',
    TAB_PLACEHOLDER_USERS: 'Users content coming soon',
    EMPTY_TITLE: 'No modules available',
    EMPTY_DESCRIPTION: 'When learning data is available, you will see it here.',
    ERROR_TITLE: 'Error loading dashboard',
    ERROR_RETRY: 'Retry',
  },
};
